import { ENUM_HTTP_ERROR_CODE } from '../../../constants';
import BaseStatusError from '../BaseStatusError';

class MethodNotAllowedError extends BaseStatusError {
  /**
   * @param {import('axios').AxiosError} error
   */
  constructor(error) {
    super(ENUM_HTTP_ERROR_CODE.methodNotAllowed, error, 'HTTP method not allowed.');
  }
}

export default MethodNotAllowedError;
